import styled from "styled-components";

export const NotesContainer = styled.section`
  display: flex;
  height: 93vh;
  color: #fff;
  background: linear-gradient(to right, #243b55, #141e30);
  justify-content: center;
  align-items: center;
  flex-direction: column;

  & h1 {
    margin: 1.5rem;
  }

  & img {
    margin: 1.5rem;
    height: 20%;
  }
`;
